import * as React from 'react';
import { SVGProps } from 'react';

const SvgColumns = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <g stroke="#313940" strokeWidth={1.5}>
      <rect x={1.75} y={1.75} width={3} height={8.5} rx={1} />
      <rect x={7.25} y={1.75} width={3} height={8.5} rx={1} />
    </g>
  </svg>
);

export default SvgColumns;
